import { useDebounce } from "@api";
import type { Override } from "@bbj-types/utils";
import SearchIcon from "@mui/icons-material/SearchOutlined";
import { InputAdornment, type InputProps, TextField, type TextFieldProps } from "@mui/material";
import type { ChangeEventHandler } from "react";

export interface ITextFieldSearchProps
  extends Override<TextFieldProps, { InputProps?: Omit<InputProps, "startAdornment"> }> {
  timeout?: number;
  onDebounce: (value: string) => void;
}

export const TextFieldSearch = ({ timeout = 750, onChange, onDebounce, ...props }: ITextFieldSearchProps) => {
  const handleDebounce = useDebounce((value: string) => onDebounce(value), timeout, [onDebounce]);

  const handleChange: ChangeEventHandler<HTMLInputElement | HTMLTextAreaElement> = (evt) => {
    onChange?.(evt);
    handleDebounce(evt.target.value);
  };

  return (
    <TextField
      {...props}
      onChange={handleChange}
      slotProps={{
        input: {
          ...props.InputProps,
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon color="secondary" />
            </InputAdornment>
          ),
        }
      }}
    />
  );
};
